import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import ContractWizard, { styles } from './ContractWizard';

import { connect } from 'react-redux';
import { Action, compose } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import {
	continueContractAsync,
	goPreviousFormAsync,
	newWizard,
	resetContractToStepAsync,
} from 'redux/actions/contractWizardActions';
import { AppState, SalesType } from '../../types/redux';

const mapStateToProps = (state: AppState) => ({
	steps: state.contractWizard.steps,
	currentStep: state.contractWizard.currentStep,
	forms: state.contractWizard.forms,
	currentForm: state.contractWizard.currentForm,
	error: state.contractWizard.error,
	contract: state.contract,
	isLoading: state.contractWizard.isLoading,
});

/* istanbul ignore next */
const mapDispatchToProps = (
	dispatch: ThunkDispatch<Promise<any>, void, Action>
) => ({
	newWizard: (salesType: SalesType) => {
		dispatch(newWizard(salesType));
	},
	continueContract: (data: any) => {
		dispatch(continueContractAsync(data));
	},
	resetContractToStep: (step: number) => {
		dispatch(resetContractToStepAsync(step));
	},
	goPreviousForm: () => {
		dispatch(goPreviousFormAsync());
	},
});

export default compose<typeof ContractWizard>(
	withTranslation('translation'),
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps),
	withRouter
)(ContractWizard);
